import AOS from 'aos'

import 'aos/dist/aos.css'

export default defineNuxtPlugin(() => {
  return {
    provide: {
      aosInit: () =>
        AOS.init({
          disable: window.innerWidth < 700,
          duration: 800,
          offset: 100,
          once: true,
        }),
      aosRefresh: () => AOS.refresh(),
    },
  }
})
